<!-- ── Bandheader: transformatie-titel + zijde-info + positielabel ─────────────── -->
<header class="band__top">
  <div class="band__title-wrap">
    <h3 class="band__title">
      {{ labels().processPrimary }}@if (labels().processSecondary) {<span class="band__title-en"> / {{ labels().processSecondary }}</span>}
    </h3>
    @if (info().helper) {
      <p class="band__helper">{{ info().helper }}</p>
    }
  </div>

  <div class="band__side">
    <span class="band__side-text">{{ labels().sideLabel }}</span>
    <span class="band__glyph" aria-hidden="true">{{ labels().planetA.glyph }}</span>
    <span class="band__side-text">{{ labels().planetA.name }}</span>
    <span class="band__side-sep">&amp;</span>
    <span class="band__glyph" aria-hidden="true">{{ labels().planetB.glyph }}</span>
    <span class="band__side-text">{{ labels().planetB.name }}</span>
  </div>

  <span class="band__position" aria-hidden="true">{{ labels().position }}</span>
</header>

<!-- ── Body: links variabele + kleurtabel, rechts cognitie + brein ───────────── -->
<div class="band__body">

  <!-- ════════ Linker kolom: variabele + 6 kleuren ════════ -->
  <section class="band__det" [attr.aria-label]="labels().variablePrimary">
    <div class="sub-head">
      <span class="sub-head__arrow" aria-hidden="true">&lt;--</span>
      <span class="sub-head__icon sub-head__icon--hex" aria-hidden="true">
        <svg viewBox="0 0 32 32"><polygon points="16,3 28,9.5 28,22.5 16,29 4,22.5 4,9.5" /></svg>
      </span>
      <h4 class="sub-head__title">
        {{ labels().variablePrimary }}@if (labels().variableSecondary) {<span class="sub-head__title-alt"> / {{ labels().variableSecondary }}</span>}
      </h4>
      <span class="sub-head__arrow" aria-hidden="true">--&gt;</span>
    </div>
    @if (info().subLabel) {
      <p class="sub-head__sub">{{ info().subLabel }}</p>
    }

    <div class="ctab">
      <div class="ctab__grid">
        @if (info().dynamic) {
          <aside class="ctab__partner" aria-hidden="true">
            <span class="ctab__partner-label">{{ labels().partnerLabel }}</span>
            <div class="ctab__partner-grid">
              <span class="ctab__connector ctab__connector--3-6"></span>
              <span class="ctab__connector ctab__connector--2-5"></span>
              <span class="ctab__connector ctab__connector--1-4"></span>
            </div>
          </aside>
        }
        <!-- Groep 1-3 -->
        @for (color of colorsLow(); track color.number) {
          <div class="ctab__row" [attr.data-color]="color.number">
            <span class="ctab__tone ctab__tone--l">
              <span class="ctab__tone-name">{{ color.tone.left.name }}</span>
              <i class="ic ic--tone fa-solid fa-{{ color.toneLeftIcon }}" aria-hidden="true"></i>
            </span>
            <span class="ctab__bar" aria-hidden="true"></span>
            <span class="ctab__mid">
              <i class="ic ic--color fa-solid fa-{{ color.icon }}" [title]="color.short" aria-hidden="true"></i>
              <span class="ctab__label">
                Kleur <b class="ctab__num">{{ color.number }}</b><span class="ctab__colon">:</span>
                <span class="ctab__name">{{ color.name }}</span>
                @if (color.gloss) { <em class="ctab__gloss">{{ color.gloss }}</em> }
              </span>
            </span>
            <span class="ctab__bar" aria-hidden="true"></span>
            <span class="ctab__tone ctab__tone--r">
              <i class="ic ic--tone fa-solid fa-{{ color.toneRightIcon }}" aria-hidden="true"></i>
              <span class="ctab__tone-name">{{ color.tone.right.name }}</span>
            </span>
          </div>
        }
        @if (info().group.low.name) {
          <aside class="ctab__brace ctab__brace--low" aria-hidden="true">
            <span class="ctab__brace-line"></span>
            <span class="ctab__brace-keynote">
              <b>{{ info().group.low.name }}</b>
              @if (info().group.low.keynote) { <em>{{ info().group.low.keynote }}</em> }
            </span>
          </aside>
        }

        <!-- Groep 4-6 -->
        @for (color of colorsHigh(); track color.number) {
          <div class="ctab__row" [attr.data-color]="color.number">
            <span class="ctab__tone ctab__tone--l">
              <span class="ctab__tone-name">{{ color.tone.left.name }}</span>
              <i class="ic ic--tone fa-solid fa-{{ color.toneLeftIcon }}" aria-hidden="true"></i>
            </span>
            <span class="ctab__bar" aria-hidden="true"></span>
            <span class="ctab__mid">
              <i class="ic ic--color fa-solid fa-{{ color.icon }}" [title]="color.short" aria-hidden="true"></i>
              <span class="ctab__label">
                Kleur <b class="ctab__num">{{ color.number }}</b><span class="ctab__colon">:</span>
                <span class="ctab__name">{{ color.name }}</span>
                @if (color.gloss) { <em class="ctab__gloss">{{ color.gloss }}</em> }
              </span>
            </span>
            <span class="ctab__bar" aria-hidden="true"></span>
            <span class="ctab__tone ctab__tone--r">
              <i class="ic ic--tone fa-solid fa-{{ color.toneRightIcon }}" aria-hidden="true"></i>
              <span class="ctab__tone-name">{{ color.tone.right.name }}</span>
            </span>
          </div>
        }
        @if (info().group.high.name) {
          <aside class="ctab__brace ctab__brace--high" aria-hidden="true">
            <span class="ctab__brace-line"></span>
            <span class="ctab__brace-keynote">
              <b>{{ info().group.high.name }}</b>
              @if (info().group.high.keynote) { <em>{{ info().group.high.keynote }}</em> }
            </span>
          </aside>
        }
        @if (info().tagline) {
          <p class="ctab__footer">{{ info().tagline }}</p>
        }
      </div>
    </div>
  </section>

  <!-- ════════ Rechter kolom: cognitie/resonantie + brein-blok ════════ -->
  <section class="band__cog" [attr.aria-label]="labels().cognitionLabel">
    <div class="sub-head sub-head--cog">
      <span class="sub-head__arrow" aria-hidden="true">&lt;--</span>
      <span class="sub-head__icon sub-head__icon--tri" aria-hidden="true">
        <svg viewBox="0 0 32 30"><polygon points="16,3 30,27 2,27" /></svg>
      </span>
      <h4 class="sub-head__title">{{ labels().cognitionLabel }}</h4>
      <span class="sub-head__arrow" aria-hidden="true">--&gt;</span>
    </div>

    <ol class="cog">
      @for (c of info().cognition; track c.tone; let i = $index) {
        <li class="cog__item" [class.cog__item--break]="i === 3" [title]="c.short">
          <i class="ic ic--cog fa-solid fa-{{ c.icon }}" aria-hidden="true"></i>
          <b>{{ c.tone }}.</b> <span class="cog__name">{{ c.name }}</span>
        </li>
        @if (i === 2) {
          <li class="cog__sep" aria-hidden="true">|</li>
        }
      }
    </ol>

    <div class="cog-groups" aria-hidden="true">
      @for (g of cognitionGroups(); track g.label) {
        <span class="cog-groups__item">
          <span class="cog-groups__line"></span>
          <span class="cog-groups__label">{{ g.label }}</span>
        </span>
      }
    </div>

    <div class="brain">
      <span class="brain__arrow" aria-hidden="true">&lt;--</span>

      <span class="brain__half brain__half--l">
        <i class="ic ic--brain fa-solid fa-{{ info().brain.left.icon }}" aria-hidden="true"></i>
        <span class="brain__txt">
          <b>{{ info().brain.left.name }}</b>
          @if (info().brain.left.short) { <em>{{ info().brain.left.short }}</em> }
        </span>
      </span>

      <span class="brain__tri" aria-hidden="true">
        <svg viewBox="0 0 100 90"><polygon points="50,5 95,85 5,85" /></svg>
        <span class="brain__tri-label">tone<br />toon</span>
      </span>

      <span class="brain__half brain__half--r">
        <span class="brain__txt">
          <b>{{ info().brain.right.name }}</b>
          @if (info().brain.right.short) { <em>{{ info().brain.right.short }}</em> }
        </span>
        <i class="ic ic--brain fa-solid fa-{{ info().brain.right.icon }}" aria-hidden="true"></i>
      </span>

      <span class="brain__arrow" aria-hidden="true">--&gt;</span>
    </div>
  </section>
</div>


